import { defineComponent } from 'vue'
import { TransferSummaryModel } from './../../Models/AmountsWithTransferSummaryModel';

export default defineComponent({
    name: "transferSummary",
    template: '#transfer-summary',
    props: {
        model: Object as () => TransferSummaryModel,
        transferHeader: String,
        regulatoryInfo: String
    }
})